import { RecordStore } from '@deqo/foundation';
import { telemetry } from '../../@vendor/Posthog';
import { waitFor } from '../../CodesThatsGottaGoSomewhereElse';
import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';

export class NextSetupProcess extends RecordStore({ progress: 0, done: false }) {

    constructor(private api: ApiClient, private boardId?: string, private surveyId?: string) {
        super();
    }

    public async go(): Promise<string> {

        telemetry.emit('setup.initiated');

        // Create account
        // eslint-disable-next-line prefer-const
        let { accountId, ...info } = await this.api.exec(v2.internal.setup.accountNext(this.surveyId));

        for (let i = 0; i < 40; i++) {

            const { remaining, total } = info.tasks;
            const progress = (total - remaining) / total;
            this.updateState({ progress });

            if (info.status === 'COMPLETED') {
                this.updateState({ done: true });
            }
            else {
                await waitFor(500);
                info = await this.api.exec(v2.operations.info(info.operationId));
            }
        }

        await waitFor(500);

        const redirect = !!this.boardId
            ? `/new/${this.boardId}`
            : '/boards?popup=welcome';

        return `/${accountId}?redirect=${encodeURIComponent(redirect)}`;
    }
}
